import * as React from 'react';
import { ITab } from '@cian/components';
import { TComponentWithTabsProps } from '../../types/tabs';
import { TChildrenTabId } from './types';
import { PikTabGroup } from '../../ui/pik_tab_group/pik_tab_group';
import { IVideoGalleryItem, VideoGallery } from '../video-gallery';

import * as styles from '../../common/common.css';

const TABS: ITab[] = [
  { id: 'playgrounds', title: 'Игровые площадки' },
  { id: 'schoolsAndKindergardens', title: 'Школы и детские сады' },
  { id: 'yards-parks', title: 'Дворы-парки' },
];

const VIDEO_TABS_GROUPS: { [key: string]: IVideoGalleryItem[] } = {
  playgrounds: [
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/c23DbrX8330/mqdefault.jpg',
      videoUrl: 'c23DbrX8330',
      title: 'Детская площадка «Пирамиды» в&nbsp;Бунинских лугах',
      text: `Для проектирования уникальной детской площадки «Пирамиды» в Бунинских лугах мы изучили лучший мировой опыт
        и создали интересный развивающий мини-городок, соответствующий самым строгим требованиям безопасности.
        Второго такого проекта в Москве нет.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/0XwlNC-0y-w/mqdefault.jpg',
      videoUrl: '0XwlNC-0y-w',
      title: 'Детская площадка «Оригами» в&nbsp;«Саларьево парке»',
      text: `Для жилого квартала «Саларьево парк» разработана площадка «Оригами»,
        построенная на концепции бесконечной игры. Большое пространство разделено на зоны для разных возрастных групп:
        здесь есть рельефные холмы, поверхности для рисования, песочница, качели и гамаки.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/2Akw14InWF4/mqdefault.jpg',
      videoUrl: '2Akw14InWF4',
      title: 'Детский праздник «ПИК-детям» в «Бунинских лугах»',
      text: `Уникальное игровое пространство «Пирамиды» в проекте «Бунинские луга» — намного больше,
        чем просто детская площадка. Посмотрите, как здесь было весело на празднике «ПИК — детям»!`,
    },
  ],
  schoolsAndKindergardens: [
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/dxPN1YvyNVg/mqdefault.jpg',
      videoUrl: 'dxPN1YvyNVg',
      title: 'Детский сад «Бунинские луга»',
      text: `Детский сад в проекте «Бунинские луга» для 150 малышей.
        Концепция проекта была разработана британским архитектурным бюро JMP.
        Центральным элементом здания стал большой атриум, наполненный естественным светом.
        На улице детские площадки для разных возрастов.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/RTeB29pyuqs/mqdefault.jpg',
      videoUrl: 'RTeB29pyuqs',
      title: 'Детский сад Green park',
      text: `Детский сад в жилом районе Green park — это яркое пространство,
        спроектированное знаменитым французским архитектором Домиником Кулоном. Похожее на огромный конструктор,
        оно сохраняет внешнюю лёгкость благодаря цветовым решениям и простым геометрическим формам:
        яркие элементы контрастируют с белым фасадом, делая здание воздушным, а огромные окна и высокие потолки
        наполняют его светом и воздухом изнутри. Внутреннее пространство устроено так, что в нём приятно играть,
        учиться и отдыхать: групповые комнаты можно расширить засчёт спален — перегородки между ними подвижны.
        Отдельные залы оборудованы для занятий музыкой и спортом, есть даже амфитеатр для театральных постановок.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/SlngwisTh3w/mqdefault.jpg',
      videoUrl: 'SlngwisTh3w',
      title: 'Открытие детского сада №22 в проекте «Бутово парк 2»',
      text: `При проектировании любого детского сада мы стремимся создать место, где малышам было бы комфортно
        проводить каждый день: есть, спать, играть и учиться. Консультации детских психологов помогают организовывать
        пространство так, чтобы сюда хотелось возвращаться.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/QnNKDDbUCos/mqdefault.jpg',
      videoUrl: 'QnNKDDbUCos',
      title: 'Открытие школы в проекте «Ярославский»',
      text: `Школа в проекте «Ярославский» — яркое выражение принципов, которые лежат в основе концепции «ПИК — детям».
        Мы понимаем, что главные люди в школе — это ученики. Поэтому всё здесь — от интерьеров до благоустройства
        территории — подчинено одной цели: сделать учёбу приятной.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/8UMy_Gtec8U/mqdefault.jpg',
      videoUrl: '8UMy_Gtec8U',
      title: 'Открытие детского сада в проекте «Восточное Бутово»',
      text: `Трёхэтажный детский сад «Восточном Бутово» — муниципальный. Мы построили его для маленьких жителей
      района и торжественно открыли в конце августа 2018 года. С тех пор здесь ежедневно играют, учатся, занимаются
      физкультурой и танцами 340 малышей.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/V4DdADPy75Y/mqdefault.jpg',
      videoUrl: 'V4DdADPy75Y',
      title: 'Открытие школы в проекте «Новокуркино»',
      text: `Школа в проекте «Новокуркино» работает с сентября 2018 года. На трёх этажах
        расположились 44 учебных класса, два спортивных зала, залы для гимнастики и танцев, а снаружи — большое
        футбольное поле с современным синтетическим покрытием.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/oixhcqMlCT8/mqdefault.jpg',
      videoUrl: 'oixhcqMlCT8',
      title: 'Детский сад «Варшавское шоссе 141»',
      text: `Один из самых необычных детских садов Москвы находится в жилом районе «Варшавское шоссе 141».
        Здание круглой формы сразу же запоминается не только детям, но и взрослым.
        В детском саду три этажа, на первом витражное остекление, на втором и третьем необычные окна в форме птиц.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/LanhFQLYgLk/mqdefault.jpg',
      videoUrl: 'LanhFQLYgLk',
      title: 'Бунинские луга. День в детском саду',
      text: `В каждом проекте мы с особым вниманием подходим к созданию современной и доступной детской инфраструктуры.
        Детский сад в «Бунинских лугах» — не исключение.
        При проектировании здания мы пользовались советами детских психологов.
        В результате получилось место, куда каждое утро дети приходят с удовольствием.
        Здесь светлые и яркие групповые комнаты с уютными спальными, просторные буфетные,
        отдельные залы для музыки и физкультуры. На прилегающей территории — безопасные детские и спортивные площадки,
        побуждающие к умственному и физическому развитию через самый органичный метод познания — игру.`,
    },
  ],
  'yards-parks': [
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/_ZxXr9Gzr48/mqdefault.jpg',
      videoUrl: '_ZxXr9Gzr48',
      title: 'Двор-парк в проекте «Бунинские луга»',
      text: `Из подъезда жители попадают в собственный двор-парк, закрытый от посторонних.
        Мы активно используем зонирование территорий во дворах,
        разделяем места для спокойного отдыха и для активных игр.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/E4BrbjSyxR8/mqdefault.jpg',
      videoUrl: 'E4BrbjSyxR8',
      title: 'Осень в дворах-парках от ПИК',
      text: `Красные листья, падающие со взрослых клёнов на ухоженный зелёный газон — обычный осенний пейзаж
        для жителей «Варшавского шоссе 141». Двор в каждом проекте ПИК — это, в первую очередь, обустроенная пешеходная
        зона для семейных прогулок. В любое время года.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/j9VLSdZvIA4/mqdefault.jpg',
      videoUrl: 'j9VLSdZvIA4',
      title: 'Двор-парк в проекте «Мещерский лес»',
      text: `Пешеходные дорожки, экологически чистые материалы, оригинальные ландшафтные решения и никаких машин.
        Во дворе-парке в «Мещерском лесу» приятно гулять взрослым, играть детям и просто находиться — всем жителям.`,
    },
    {
      videoPreviewUrl: 'https://img.youtube.com/vi/oixhcqMlCT8/mqdefault.jpg',
      videoUrl: 'oixhcqMlCT8',
      title: 'Двор-парк в проекте «Варшавское шоссе 141»',
      text: `Дворы-парки ПИК — это продуманность в каждом квадратном метре. Грамотное зонирование делит территорию
        на зоны для прогулок, активного и спокойного отдыха: здесь можно и покататься на самокате, и погулять
        с ребенком, и посидеть на скамейке в тени раскидистого дерева.`,
    },
  ],
};

export class ChildrenComponent extends React.Component<TComponentWithTabsProps> {
  public render() {
    const {
      tabs: { children: activeTab },
    } = this.props;

    return (
      <div>
        <p className={styles['pik-standard-description']}>
          В&nbsp;новых жилых кварталах ПИК собственные дворы-парки, закрытые от&nbsp;посторонних, где&nbsp;реализовано
          креативное, безопасное игровое пространство для&nbsp;детей разного возраста. Наши&nbsp;школы и детские сады
          спроектированы с&nbsp;учётом всех потребностей ребёнка. Только так можно создать действительно комфортную
          жилую среду.
        </p>

        <PikTabGroup activeTab={activeTab} onTabClick={this.handleTabToggle} tabs={TABS} />

        {this.renderTabsPage()}
      </div>
    );
  }

  private handleTabToggle = (value: TChildrenTabId) =>
    this.props.changeTabs({
      ...this.props.tabs,
      children: value,
    });

  private renderTabsPage = (): React.ReactNode => {
    const {
      tabs: { children: activeTab },
    } = this.props;

    return <VideoGallery items={VIDEO_TABS_GROUPS[activeTab]} />;
  };
}
